import { AxiosError } from "axios";
import { METHODS } from "../../../../data/api-method-constants"
import { fetchCommonData } from "../../../../redux/slices"
import store from "../../../../redux/store"
import { ENDPOINT } from "../../../../services/apiUrls"
import { FilterDataType } from "../recon-context";
import { DATE_TIME_FORMATS } from "../../../../data/constants";

function fetchUploadedFiles(props: { limit: number; page: number; }) {
  return new Promise((resolve, reject) => {
    function callback(response: any) {
      if (response.code || response instanceof AxiosError) {
        reject(response);
      }
      resolve(response);
    }
    store.dispatch(fetchCommonData({
      method: METHODS.POST,
      url: ENDPOINT.RECON.uploadedFiles,
      callback,
      body: { status: "COMPLETED", limit: props.limit, page: props.page },
      errorCallback: true
    }))
  })
}

function fetchPendingReports(filterData: FilterDataType) {
  return new Promise((resolve, reject) => {
    function callback(response: any) {
      if (response.code || response instanceof AxiosError) {
        reject(response);
      }
      resolve(response);
    }
    store.dispatch(fetchCommonData({
      method: METHODS.POST,
      url: ENDPOINT.RECON.uploadedFiles,
      callback,
      body: { status: "PENDING" },
      errorCallback: true
    }))
  })
}

function uploadFiles() {

}

function deleteReconFiles(filterData: FilterDataType) {
  
}

function fetchReconSummary(filterData: FilterDataType & { limit: number; page: number }, outletWise = false) {
  const dataToSend = {
    outletWise,
    aggregator: filterData.aggregator ? [filterData.aggregator] : [],
    firstDate: filterData.dateRange?.[0]?.format(DATE_TIME_FORMATS.yearMonthDay),
    lastDate: filterData.dateRange?.[1]?.format(DATE_TIME_FORMATS.yearMonthDay),
    branchIds: filterData.branchIds,
    limit: filterData.limit,
    page: filterData.page
  };
  return new Promise((resolve, reject) => {
    function callback(response: any) {
      if (response.code || response instanceof AxiosError) {
        reject(response);
      }
      resolve(response);
    }
    store.dispatch(fetchCommonData({
      method: METHODS.POST,
      url: ENDPOINT.RECON.reconSummary,
      callback,
      body: dataToSend,
      errorCallback: true
    }))
  })
}

function downloadReconSummary(props: { branchIds: string[]; periods?: string[]; outletIds?: string[], saveReport?: boolean, attachmentIds?: string[] }) {
  const dataToSend = { ...props };
  return new Promise((resolve, reject) => {
    function callback(response: any) {
      if (response.code || response instanceof AxiosError) {
        reject(response);
      }
      resolve(response);
    }
    store.dispatch(fetchCommonData({
      method: METHODS.POST,
      url: ENDPOINT.RECON.downloadReconReports,
      callback,
      body: dataToSend,
      errorCallback: true
    }))
  })
}

function fetchReconLogs(props: { limit: number; page: number}) {
  return new Promise((resolve, reject) => {
    function callback(response: any) {
      if (response.code || response instanceof AxiosError) {
        reject(response);
      }
      resolve(response);
    }
    store.dispatch(fetchCommonData({
      method: METHODS.POST,
      url: ENDPOINT.RECON.uploadedFiles,
      body: props,
      callback,
      errorCallback: true
    }))
  })
}


export const reconServices = {
  fetchUploadedFiles,
  fetchPendingReports,
  uploadFiles,
  deleteReconFiles,
  fetchReconSummary,
  downloadReconSummary,
  fetchReconLogs
}